<ion-skeleton-text
  animated
  class="w-full h-full rounded bg-ncis-neutral-300 m-0"
></ion-skeleton-text>
